<mat-dialog-actions *ngIf="onlyCancel" class="dialog-actions">
  <button mat-button (click)="onClickCancel()" [disabled]="!isCancelEnabled">
    {{ cancelTitle }}
  </button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="!onlyCancel" class="dialog-actions">
  <button mat-button (click)="onClickCancel()" [disabled]="!isCancelEnabled">
    {{ cancelTitle }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onClickSubmit()"
    [disabled]="!isSubmitEnabled"
  >
    {{ submitTitle }}
  </button>
</mat-dialog-actions>
